import React, { useState, useEffect } from 'react';
import { Select, MenuItem, Button, Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import Sidebar from '../../components/sidebar';
import Header from '../../components/header';
import { useNavigate } from 'react-router-dom';
import userService from '../../services/user_service';
import userConstants from '../../constants/user_constants';


const ManagementUserPage = () => {
  const navigate = useNavigate(); 
  const [users, setUsers] = useState([]);
  const [guests, setGuests] = useState([]);
  const [members, setMembers] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [service, setService] = useState([]);

  const [isLoading, setIsLoading] = useState(false)

  const fetchUsers = async () => {
    setIsLoading(true)
    try {
      const response = await userService.getAllUser();
      setUsers(response.data);
      setIsLoading(false)
    } catch (error) {
      console.error(error);
    }
    
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    if(users.length !== 0){
      setGuests(users.filter(user => user.role === userConstants.userRoleConstants.GUEST));
      setMembers(users.filter(user => user.role === userConstants.userRoleConstants.MEMBER));
      setTrainers(users.filter(user => user.role === userConstants.userRoleConstants.PERSONAL_TRAINER));
      setService(users.filter(user => user.role === userConstants.userRoleConstants.CUSTOMER_SERVICE));
    }
  }, [users]);

  
  const handleDelete = async (user_id) => {
    console.log("handleDelete is called with user_id: ", user_id);
    const confirmChange = window.confirm("Are you sure you want to delete this user?");
    if (confirmChange) {
      const response = await userService.deleteOneUser(user_id);
  
      console.log("handleDelete response: ", response);
  
      if(response && response.status === 200){
        setUsers(users => users.filter(user => user.id !== user_id))
      } else if(response.message.includes('Cannot delete or update a parent row')) {
        alert('Cannot delete this user as they have ongoing activities.')
      }
    }
  };  
  
  const handleChangeRole = async (user_id, role) => {
    const confirmChange = window.confirm("Are you sure you want to change the user's role?");
    if (confirmChange) {
      const updateData = {role: role}
      const response = await userService.updateOneUser(user_id, updateData);

      if(response.status === 200){
        fetchUsers();
      }
      console.log(response);
    }
  };



  return users.length === 0 ? <>Loading...</> : (
    <>
      <Box sx={{ top: 0, left: 0, width: '100%', zIndex: 2 }}>
        <Header />
      </Box>
      <Box sx={{ position: 'absolute', top: 64, left: 0, height: '100%', zIndex: 2 }}>
        <Sidebar activeButton="Manajemen User" />
      </Box>
      <Box sx={{ fontFamily: 'inherit' }}>
        <Typography sx={{ fontFamily: 'Titillium Web',marginLeft: '280px' , mt: 2, fontWeight: 'bold' }} variant="h6" component="h3" color="#1C1C1E" mb={1}>
          Manajemen User
        </Typography>
        <Button sx={{ left:280, boxShadow: 5, textTransform: 'none', bgcolor: '#1D375C', color: 'white', mb: 2 }} onClick={() => navigate('/dashboard/management/user/add')}>
          <Typography variant="subtitle1" sx={{ fontFamily: 'Titillium Web', fontWeight: 'bold', fontSize: 14 }}>
            + Tambah User
          </Typography>
        </Button>

        <Box sx={{ marginLeft: '280px' }} display="flex"  mb={2}>

          {/* Handle Guest */}
          <Box mb={2} mr={2}>
            <Box sx={{ boxShadow: 3, borderRadius: '5px', bgcolor: "white", p: 2, flexGrow: 1 }}>
              <Typography variant="h6" component="h3" color="#1C1C1E" mb={1}>
                Guest
              </Typography>
              <Typography variant="h4" component="h4" color="#1C1C1E">
                {guests.length}
              </Typography>
            </Box>
            {/* List Guest  */}
            <Box sx={{ boxShadow: 3, borderRadius: '5px', bgcolor: "white", p: 2, flexGrow: 1, mt: 2 }}>
              <Typography variant="h6" component="h3" color="#1C1C1E" mb={1}>
                Guest List
              </Typography>
              <List>
                {guests.map(user => (
                  <ListItem key={user.id}>
                    <ListItemText primary={user.name} secondary={`Email: ${user.email}, Phone: ${user.phone}`} />
                    <Button sx={{bgcolor:"#FF5630", mr:2}} variant="contained" onClick={() => handleDelete(user.id)}>Hapus</Button>
                    {/* Ubah Role  */}
                    <Select value={user.role} onChange={(event) => handleChangeRole(user.id, event.target.value)}>
                      <MenuItem value={userConstants.userRoleConstants.GUEST}>Guest</MenuItem>
                      <MenuItem value={userConstants.userRoleConstants.MEMBER}>Member</MenuItem>
                      <MenuItem value={userConstants.userRoleConstants.PERSONAL_TRAINER}>Personal Trainer</MenuItem>
                      <MenuItem value={userConstants.userRoleConstants.CUSTOMER_SERVICE}>Customer Service</MenuItem>
                    </Select>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>

          {/* Handle Member */}
          <Box mb={2} mr={2}>
            <Box sx={{ boxShadow: 3, borderRadius: '5px', bgcolor: "white", p: 2, flexGrow: 1 }}>
              <Typography variant="h6" component="h3" color="#1C1C1E" mb={1}>
                Member
              </Typography>
              <Typography variant="h4" component="h4" color="#1C1C1E">
                {members.length}
              </Typography>
            </Box>
            {/* List Member  */}
            <Box sx={{ boxShadow: 3, borderRadius: '5px', bgcolor: "white", p: 2, flexGrow: 1, mt: 2 }}>
              <Typography variant="h6" component="h3" color="#1C1C1E" mb={1}>
                  Member List
              </Typography>
              <List>
                {members.map(user => (
                  <ListItem key={user.id}>
                    <ListItemText primary={user.name} secondary={`Email: ${user.email}, Phone: ${user.phone}`} />
                    <Button sx={{bgcolor:"#FF5630"}} variant="contained" onClick={() => handleDelete(user.id)}>Hapus</Button>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>

          {/* Handle PT */}
          <Box mb={2} mr={2}>
            <Box sx={{ boxShadow: 3, borderRadius: '5px', bgcolor: "white", p: 2, flexGrow: 1 }}>
              <Typography variant="h6" component="h3" color="#1C1C1E" mb={1}>
                Personal Trainer
              </Typography>
              <Typography variant="h4" component="h4" color="#1C1C1E">
                {trainers.length}
              </Typography>
            </Box>
            {/* List Personal Trainer  */}
            <Box sx={{ boxShadow: 3, borderRadius: '5px', bgcolor: "white", p: 2, flexGrow: 1, mt: 2 }}>
              <Typography variant="h6" component="h3" color="#1C1C1E" mb={1}>
                Personal Trainer List
              </Typography>
              <List>
                {trainers.map(user => (
                  <ListItem key={user.id}>
                    <ListItemText primary={user.name} secondary={`Email: ${user.email}, Phone: ${user.phone}`} />
                    <Button sx={{bgcolor:"#FF5630"}} variant="contained" onClick={() => handleDelete(user.id)}>Hapus</Button>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>

          {/* Handle CS */}
          <Box mb={2} mr={2}>
            <Box sx={{ boxShadow: 3, borderRadius: '5px', bgcolor: "white", p: 2, flexGrow: 1 }}>
              <Typography variant="h6" component="h3" color="#1C1C1E" mb={1}>
                Customer Service
              </Typography>
              <Typography variant="h4" component="h4" color="#1C1C1E">
                {service.length}
              </Typography>
            </Box>
            {/* List CS  */}
            <Box sx={{ boxShadow: 3, borderRadius: '5px', bgcolor: "white", p: 2, flexGrow: 1, mt:2}}>
              <Typography variant="h6" component="h3" color="#1C1C1E" mb={1}>
                CS List
              </Typography>
              <List>
                {service.map(user => (
                  <ListItem key={user.id}>
                    <ListItemText primary={user.name} secondary={`Email: ${user.email}, Phone: ${user.phone}`} />
                    <Button sx={{bgcolor:"#FF5630"}} variant="contained" onClick={() => handleDelete(user.id)}>Hapus</Button>
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>
        </Box>

      </Box></>
  );
};

export default ManagementUserPage;